export default {
  venueBgColor: '#1A1F36',
};
